export function stripFootnotes(text) {
  if (!text) return text;
  return text.replace(/\{\d+\}/g, '');
}

export function formatVerseHtml(text) {
  if (!text) return text;
  return stripFootnotes(text).replace(/\[([^\]]+)\]/g, '<em>$1</em>');
}

export function stripBrackets(text) {
  if (!text) return text;
  return text.replace(/[[\]]/g, '');
}

export function tokenizeVerseText(text) {
  const cleaned = stripFootnotes(text);
  const parts = cleaned.split(/(\[[^\]]*\])/);
  const tokens = [];
  let id = 0;

  parts.forEach(part => {
    const isItalic = part.startsWith('[') && part.endsWith(']');
    const content = isItalic ? part.slice(1, -1) : part;
    const words = content.split(/\s+/).filter(Boolean);
    words.forEach(word => {
      tokens.push({ id: id++, text: word, italic: isItalic, hidden: false, revealed: false });
    });
  });

  return tokens;
}
